module.exports = __webpack_public_path__ + "img/logo.468416d8.png";